<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  <p>{{ message }}</p>
  @if (question) {
    <p class="mt-3">{{ question }}</p>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary me-auto" (click)="cancel()">{{ cancelButtonText }}</button>
  @if (action3ButtonText) {
    <button type="button" class="btn btn-info me-1" (click)="action3()" [disabled]="action3Disabled">
      {{ action3ButtonText }}
    </button>
  }
  <button type="button" class="btn btn-info me-1" (click)="action2()" [disabled]="action2Disabled">
    {{ action2ButtonText }}
  </button>
  <button type="submit" class="btn btn-info" (click)="action1()" [disabled]="action1Disabled" #submitButton>
    {{ action1ButtonText }}
  </button>
</div>
